<template>
	<div>
		<div class="border-top">
			<SOFilterTitle :title="title" :diterapkan="diterapkan.jenisPembayaran" :id="id"/>
			<div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
				<SOInputCheckbox
					:checkboxes="jenisPembayaran"
					:checked="filterItem.jenisPembayaran"
					@selected="selected"
				/>
			</div>
		</div>
		<div class="border-top" v-if="filterItem.jenisPembayaran.filter(v => v === '3').length !== 0 && useAkunDebit">
			<SOFilterTitle :title="'Akun Pembayaran Debit'" :diterapkan="diterapkan.akunDebit"
			               :id="'akun-pembayaran-debit'"/>
			<div class="p-l-24 p-r-24 p-d-24" :id="'akun-pembayaran-debit'">
				<SOFilterSelectSkeleton v-if="pageSetting.loading"/>
				<SOInputSelect
					v-if="!pageSetting.loading"
					:title="'Akun Pembayaran Debit'"
					:selected="filterItem.jenisPembayaranAkunDebit"
					:placeholder="'Pilih jenis akun debit'"
					:options="optionsDebit"
					@option-selected="selectedAkunDebit"
				/>
			</div>
		</div>
        <div class="border-top" v-if="filterItem.jenisPembayaran.filter(v => v === '11').length !== 0 && useAkunEdc">
            <SOFilterTitle :title="'Akun Pembayaran EDC'" :diterapkan="diterapkan.akunEDC"
                           :id="'akun-pembayaran-edc'"/>
            <div class="p-l-24 p-r-24 p-d-24" :id="'akun-pembayaran-edc'">
                <SOFilterSelectSkeleton v-if="pageSetting.loading"/>
                <SOInputSelect
                    v-if="!pageSetting.loading"
                    :title="'Akun Pembayaran EDC'"
                    :selected="filterItem.jenisPembayaranAkunEDC"
                    :placeholder="'Pilih jenis akun edc'"
                    :options="optionsEDC"
                    @option-selected="selectedAkunEDC"
                />
            </div>
        </div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import SOFilterSelectSkeleton from "@/so-components/global/filter/skeleton/SOFilterSelectSkeleton";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";

export default {
	name: "SOFilterJenisPembayaran",
	components: {
		SOFilterTitle,
		SOInputCheckbox,
		SOFilterSelectSkeleton,
		SOInputSelect,
	},
	props: {
		id: String,
		useAkunEdc: {
			type: Boolean,
			default: true,
		},
		useAkunDebit: {
			type: Boolean,
			default: true,
		},
		title: {
			type: String,
			default: "Jenis Pembayaran",
		},
		dataOptions: {
			type: Array,
			default: function () {
				return [
					{
						id: "jenis-pembayaran-1",
						value: "1",
						title: "Tunai",
						checked: false,
						titleBold: false,
					},
					{
						id: "jenis-pembayaran-2",
						value: "3",
						title: "Debit",
						checked: false,
						titleBold: false,
					},
					{
						id: "jenis-pembayaran-3",
						value: "4",
						title: "E-payment",
						checked: false,
						titleBold: false,
					},
                    {
                        id: "jenis-pembayaran-4",
                        value: "11",
                        title: "EDC",
                        checked: false,
                        titleBold: false,
                    },
					{
						id: "jenis-pembayaran-5",
						value: "10",
						title: "QRIS",
						checked: false,
						titleBold: false,
					},
					{
						id: "jenis-pembayaran-6",
						value: "5",
						title: "Deposit",
						checked: false,
						titleBold: false,
					},
					// {
					// 	id: "jenis-pembayaran-5",
					// 	value: "6",
					// 	title: "Paylink",
					// 	checked: false,
					// 	titleBold: false,
					// },
				];
			}
		}
	},
	computed: {
		...mapGetters("filterGlobalModule", {
			filterItem: "getFilterItem"
		}),
		...mapGetters("metaModule", {
			akunDebit: "getAkunDebit"
		})
	},
	data() {
		return {
			pageSetting: {
				loading: true,
			},
			optionsDebit: [],
			optionsEDC: [],
			jenisPembayaran: {
				name: "jenis-pembayaran",
				data: this.dataOptions

			},
			diterapkan: {
				jenisPembayaran: false,
				akunDebit: false,
                akunEDC: false,
			},
		}
	},
    watch: {
        "filterItem.jenisPembayaran": {
            handler: function () {
                if (this.filterItem.jenisPembayaran.filter(v => v === '3').length === 0) {
                    this.selectedAkunDebit("")
                }
                if (this.filterItem.jenisPembayaran.filter(v => v === '11').length === 0) {
                    this.selectedAkunEDC("")
                }
            },
        },
    },
	mounted() {
		this.getAkunDebit()
        this.getAkunEDC()
		if (this.title === "") {
			this.title = "Jenis Pembayaran"
		}
		this.diterapkan.jenisPembayaran = this.filterItem.jenisPembayaran.length > 0
		this.diterapkan.akunDebit = this.filterItem.jenisPembayaranAkunDebit !== ""
		this.diterapkan.akunEDC = this.filterItem.jenisPembayaranAkunEDC !== ""
	},
	methods: {
		async getAkunDebit() {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("metaModule/fetchAkunDebit")
			this.pageSetting.loading = false
			if (res.success) {
				this.optionsDebit = []
				this.akunDebit.forEach(v => {
					this.optionsDebit = [
						...this.optionsDebit, {
							id: v.idakun,
							text: v.nama_akun,
						},
					]
				})
			} else {
				this.$toast.error(res.err)
			}
		},
        async getAkunEDC() {
            this.pageSetting.loading = true
            const res = await this.$store.dispatch("metaModule/fetchAkunEDC")
            this.pageSetting.loading = false
            if (res.success) {
                this.optionsEDC = []
                this.akunDebit.forEach(v => {
                    this.optionsEDC = [
                        ...this.optionsEDC, {
                            id: v.idakun,
                            text: v.nama_akun,
                        },
                    ]
                })
            } else {
                this.$toast.error(res.err)
            }
        },
		selected(val) {
			let temp = this.filterItem
			temp.jenisPembayaran = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan.jenisPembayaran = this.filterItem.jenisPembayaran.length > 0
		},
		selectedAkunDebit(val) {
			let temp = this.filterItem
			temp.jenisPembayaranAkunDebit = val
			this.$store.commit("filterGlobalModule/setFilterItem", temp)
			this.diterapkan.akunDebit = this.filterItem.jenisPembayaranAkunDebit !== ""
		},
        selectedAkunEDC(val) {
            let temp = this.filterItem
            temp.jenisPembayaranAkunEDC = val
            this.$store.commit("filterGlobalModule/setFilterItem", temp)
            this.diterapkan.akunEDC = this.filterItem.jenisPembayaranAkunEDC !== ""
        },
	}
}
</script>